import useSWR, { mutate } from 'swr';
import api from '../utils/api';
import { BalanceResponse } from '../types/Usage';

const fetchBalance = async () => {
  return await api.get('/subscriptions/v1/credits/me/balance');
};

export const useCredits = () => {

  const { data, error, isLoading } = useSWR<{ data: BalanceResponse }>('/subscriptions/v1/credits/me/balance', fetchBalance);

  const updateCredits = async () => {
    try {
      const updatedBalance = await fetchBalance();
      mutate('/subscriptions/v1/credits/me/balance', updatedBalance);
    } catch (error) {
      console.error(error, 'error is generated by calling this api endpoint /subscriptions/v1/credits/me/balance and fetchBalance() ');
    }
  };

  return {
    data: data,
    isLoading,
    error,
    updateCredits
  };
};
